import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import logoigt from "../../assets/logoigt.png";
import "../../css/pages/login.css";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearErrors, forgotPassword } from "../../features/user/userSlice";

const ForgotPassword = () => {
  const [username, setUsername] = useState("");

  const dispatch = useDispatch();

  const { loading, error, forgotPasswordSuccess } = useSelector(
    (state) => state.user,
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(forgotPassword(username));
  };

  useEffect(() => {
    dispatch(clearErrors());
  }, [dispatch]);

  return (
    <Grid className="signin pt-10">
      <Grid
        item
        xs={8}
        md={4}
        component={Paper}
        elevation={3}
        sx={{
          borderRadius: "4px",
        }}
        className="auth-card"
      >
        <Box
          sx={{
            margin: "64px 32px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              maxWidth: "200px",
              marginBottom: "20px",
            }}
          >
            <img src={logoigt} alt="logo" style={{ width: "100%" }} />
          </Box>

          {/* Heading */}
          <Typography
            component="h1"
            variant="h5"
            sx={{
              color: "#585858",
              mb: 1,
            }}
          >
            Forgot Password
          </Typography>

          {/* Description */}
          <Typography
            variant="body2"
            align="center"
            sx={{
              color: "#777",
              mb: 3,
              width: {
                xs: "100%",
                sm: "320px",
              },
            }}
          >
            Enter your username and we'll send password reset instructions.
          </Typography>
          <Box
            sx={{
              width: {
                xs: "100%",
                sm: "400px",
              },
            }}
          >
            {/* Form */}
            <form onSubmit={handleSubmit}>
              <TextField
                variant="outlined"
                margin="normal"
                required
                fullWidth
                id="username"
                name="username"
                label="Username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />

              <Button
                type="submit"
                fullWidth
                variant="contained"
                disabled={loading}
                sx={{
                  mt: 2,
                  py: 1.2,
                }}
              >
                {loading ? "Sending..." : "Send Reset Link"}
              </Button>

              <Button
                component={Link}
                to="/login"
                fullWidth
                variant="text"
                sx={{
                  mt: 1,
                }}
              >
                Back to Sign In
              </Button>
            </form>
          </Box>

          {/* Success Message */}
          {forgotPasswordSuccess && (
            <Typography
              sx={{
                color: "green",
                mt: 2,
                textAlign: "center",
                width: "100%",
                maxWidth: "400px",
                wordBreak: "break-word",
              }}
            >
              {forgotPasswordSuccess}
            </Typography>
          )}

          {/* Error Message */}
          {error && (
            <Typography
              sx={{
                color: "red",
                mt: 2,
                textAlign: "center",
                width: "100%",
                maxWidth: "400px",
                wordBreak: "break-word",
              }}
            >
              {error}
            </Typography>
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ForgotPassword;
